import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { selectAccessToken } from '../slices/staffSlice';
import { fetchRequests } from '../Requests/getRequests';
import { show } from '../slices/toastSlice';
import { authStaff } from '../utils/constants';
import { useNavigate } from 'react-router-dom';

// Fetches all successful auto-debit transactions from Npontu
function useNpontuSuccessfulTransactions() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const accessToken = useSelector(selectAccessToken);
    const [isLoading, setIsLoading] = useState(true);
    const [successfulTransactions, setSuccessfulTransactions] = useState([]);

    useEffect(() => {
        let unsubscribed = false;

        const getSuccessfulTransactions = async() => {
            setIsLoading(true);

            let headers = authStaff(accessToken);
            let url = `/payments/npontu/transactions/successful`;

            let res = await fetchRequests(url, "GET", headers, {}, {});
            setIsLoading(false);

            if(res?.code === 401){
                sessionStorage.clear();
                navigate("/login");
                dispatch(show({
                    type : "error",
                    state : true,
                    message : "Your session has expired. Please login to continue."
                }));
                return;
            }

            if(res?.err){
                dispatch(show({
                    type : "error",
                    state : true,
                    message : res?.err
                }));
                return;
            }

            if(!unsubscribed){
                setSuccessfulTransactions(res?.data?.data ?? []);
            }
        }

        getSuccessfulTransactions();

        return () => {
            unsubscribed = true;
        }
    }, [dispatch, navigate, accessToken])

    return { isLoading, successfulTransactions }
}

export default useNpontuSuccessfulTransactions
